<template>
    <div>
        <Modal
            :value="showModel"
            :title="title"
            :footer-hide="true"
            :mask-closable="false"
            @on-cancel="cancel"
            @on-visible-change="openOrClose"  :styles="{'top':'20%','min-width':'700px'}">

            <div>
                <Form ref="formData" :model="formData" :rules="ruleCustom" :label-width="80">
            
                   <FormItem :label="$t('deviceManage.Installer')" prop="id"  style="width: 500px" class="ivu-form-item-required">
                       <SearchSelectRecycle ref="dealerRef" refName="dealerRef"   :url="searchDealerUrl" listName="dealersList" labelName='nikeName'  :selectUrlQuery='{}'  isMultiple='2'  valName='id' keyword="nikeName" :labelInValue="true" :placeholderText="$t('selectPlaceholder')"  @setSelected="setSelectValNew($event,'id')"></SearchSelectRecycle>
                    </FormItem>

                    <FormItem>
                        <Button :loading="disabled"  type="primary" @click="subData('formData')" style="margin-right:20px">{{$t('save')}}</Button>
                        <Button :disabled="disabled" @click="cancel">{{$t('cancel')}}</Button>
                    </FormItem>
                </Form>
            </div>
         
        </Modal>
    </div>
    </template>
    <script>
    /**
     * 弹框
     * @param showModel boolean 对话框开关 true false
     * @param fn function 回调函数
     * @param type Number 类型 1添加 2编辑
     * @param editFormData Object 编辑时的数据
     */
    import common from '@/common/common';
    import { mapState } from 'vuex'
    import SearchSelectRecycle from '@/views/common/selectListRecycle.vue'; 
        export default {
            props: {
                showModel: Boolean,
                fn:Function,
                type:Number,
                editFormData:Array,
            },
            name: "assignedVendorModel",
            components: {
                SearchSelectRecycle
            },
            data() {
                return {   
                    disabled: false,//禁用确定按钮
                    title: '',//弹框标题
                    formData: {//表单数据
                        id:'',
                       snList:[]
                    }
                }
            },
            computed:{
                searchDealerUrl(){
                    return this.config.urlArray.getInstalls
                },
                ...mapState(['local','selectId']),
                ruleCustom(){
                    return {//验证
                        id: [
                            {required: true, message: this.$t('required'),trigger: 'change' },
                        ]
                    }
                }
    
            },
            created(){
               
            },
            methods: {
                setSelectValNew(e,key){
                   
                    if(e){
                          this.formData[key] = e[key]+''
                    }else{
                         this.formData[key] = ''
                    }
                },
                openOrClose(value) {
                    if(value === true) {
                        this.title = this.$t('deviceManage.AssignedVendor')
                        this.formData.snList =  this.editFormData.map(item => item.serialNumber)
                        
                        if(!this.formData.dealerId){
                            this.$refs.dealerRef.getData()
                        }else{
                            this.$nextTick(async ()=>{//select赋值
                                this.$refs.dealerRef.setDefVal({
                                    id:Number(this.formData.dealerId),
                                })
                            });   
                        }
       
                         
                    } else {
    
                        this.$refs.dealerRef.clearVal();
                        this.resetForm();//重置表单
                    }
                },
                subData(name) {//提交表单
         
                    console.log(this.formData)
                    this.$refs[name].validate((valid) => {
                        if (valid) {
                            this.disabled = true;        
                            let url = this.config.urlArray.moveInstaller
                            let params = {
                                installerId:this.formData.id,
                                snList:this.formData.snList,
                            }
                     
                            this.axios.post(url, params).then((result) => {
                              
                                common.ajaxMsg(result.data,true,()=>{//提交表单后的回调处理
                                    this.resetForm();//重置表单
                                    this.fn()
                                },()=>{ this.disabled = false;})
                                
                            }).catch((err) => {
                                this.disabled = false;
                            });
                            
                        }
                    })
                },
                cancel() {//对话框关闭
                    this.resetForm()
                    this.$emit('update:showModel',false);
                },
                resetForm() {//重置表单
                    this.$refs.formData.resetFields();//重置表单
                    Object.keys(this.formData).forEach(key=>{this.formData[key]=''})
                    this.disabled = false;//恢复提交按钮为激活状态
                }
            }
        }
    </script>
    <style scoped>
    
    </style>
    